const palette = {
  black: 'rgb(29, 31, 32)',
  orange: 'rgb(254, 163, 49)',
  gray: 'rgb(147, 147, 162)',
  light_gray: 'rgb(225, 225, 232)',
  light_gray2: 'rgb(216, 216, 216)',
  light_gray3: 'rgb(198, 198, 209)',
  gray_transparency: 'rgba(32, 32, 38, 0.2)',
  light_blue: 'rgb(66, 129, 255)',
  blue: 'rgb(0,0,255)',
  blue_purple: 'linear-gradient(-135deg, rgb(66, 129, 255) 0%, rgb(117, 117, 255) 100%)',
  blue_purple2: 'rgb(117, 117, 255)',
  light_red: 'rgb(242, 93, 82)',
  white: 'rgb(255,255,255)',
  white_opacity: 'linear-gradient(to bottom, rgba(255,255,255, 0) 0%, rgba(255,255,255, .5) 90%)',
  horizontal_white_opacity:
    'linear-gradient(to right, rgba(255,255,255, 0) 0%, rgba(255,255,255, .5) 90%)',
  green: 'rgb(0, 128, 0)',
};

export default palette;
